import { CreditNoteRepository } from "../repositories/CreditNoteRepository";
import { CreditNoteDataEntity, CreditNoteEntity } from "../entities/CreditNoteEntity";

/**
 * Save Credit Note As Draft Use Case
 * Saves a credit note as draft (creates or updates it with draft status)
 */
export class SaveCreditNoteAsDraftUseCase {
  constructor(private repository: CreditNoteRepository) {}

  async execute(
    creditNoteData: CreditNoteDataEntity,
    options?: {
      jobid?: string | null;
      folder_id?: string | null;
      company_id?: number | null;
      gst_rates?: any;
      gst_types?: any;
      is_tds_applied?: number;
      tds_tax_id?: string | null;
      tds_tax_amount?: number | null;
      tds_tax_percentage?: number | null;
      tds_tax_name?: string | null;
      tds_section?: string | null;
    }
  ): Promise<CreditNoteEntity> {
    return await this.repository.saveCreditNoteAsDraft(creditNoteData, options);
  }
}

